import {Component, input} from '@angular/core';

@Component({
  selector: 'dm-loading',
  imports: [],
  templateUrl: './loading.html',
  styleUrl: './loading.scss',
})
export class Loading {
  active = input<boolean>(true);
}
